<template>
    <v-text-field
        ref="field"
        class="code-field"
        :value="value"
        inputmode="numeric"
        autocomplete="one-time-code"
        maxlength="9"
        outlined
        @input="onInput"
        @keyup.enter="$emit('enter')"
    ></v-text-field>
</template>

<script>
const LENGTH = 8;

export default {
    props: {
        value: { type: String, default: "" },
    },

    methods: {
        onInput(raw) {
            // A code is pasted as "1234 5678" or with other characters around it; keep the digits only.
            const digits = (raw || "").replace(/\D/g, "").slice(0, LENGTH);

            // The field would otherwise keep showing what was typed when the cleaned value equals the old one.
            if (digits !== raw && this.$refs.field) this.$refs.field.lazyValue = digits;

            this.$emit("input", digits);
            if (digits.length === LENGTH) this.$emit("complete", digits);
        },

        focus() {
            if (this.$refs.field) this.$refs.field.focus();
        },
    },
};
</script>

<style>
.code-field input {
    text-align: center;
    font-size: 1.6rem;
    font-family: monospace;
    font-weight: 700;
    letter-spacing: 0.3em;
    /* The last letter-spacing trails the text; the same padding on the left keeps the digits optically centered. */
    padding-left: 0.3em;
}

.code-field input::placeholder {
    font-weight: 400;
    opacity: 0.4;
}

.code-field .v-messages {
    text-align: center;
}
</style>
